import { differenceInCalendarDays, parseISO } from "date-fns";

import { FiClock } from "react-icons/fi";

import Badge from "@/components/ui/badge";

import { formatDate, toClinicDateKey } from "@/lib/format-data";

/** Days before `validUntil` at which a GFE is flagged as needing renewal. */
export const GFE_EXPIRING_SOON_DAYS = 30;

export function isGFEExpiringSoon(
  validUntil: string,
  isExpired: boolean,
  now: Date = new Date(),
): boolean {
  if (isExpired) return false;
  // Count days in the clinic timezone (as formatDate shows them), parsing the
  // API's naive timestamps as UTC. Guard on the date too: `isExpired` is a
  // server snapshot and can be stale.
  const daysUntilExpiry = differenceInCalendarDays(
    parseISO(toClinicDateKey(validUntil)),
    parseISO(toClinicDateKey(now)),
  );
  return daysUntilExpiry >= 0 && daysUntilExpiry <= GFE_EXPIRING_SOON_DAYS;
}

export function GFEExpiringSoonBadge({
  validUntil,
  isExpired,
}: {
  validUntil: string;
  isExpired: boolean;
}) {
  if (!isGFEExpiringSoon(validUntil, isExpired)) return null;
  return (
    <Badge variant="warning">
      <FiClock className="mr-1 h-3 w-3" />
      Expires soon
    </Badge>
  );
}

export function GFEValidUntil({
  validUntil,
  isExpired,
}: {
  validUntil: string;
  isExpired: boolean;
}) {
  return (
    <span className="text-caption text-foreground-secondary">
      {`${isExpired ? "Expired" : "Valid until"} ${formatDate(validUntil)}`}
    </span>
  );
}
